import * as signalR from '@microsoft/signalr'
import { ref } from 'vue'

const EStatus = Object.freeze({
  Undefined: 0,
  Approve: 1,
  InProgress: 2
});

const timeoutReconnect = 5000

// signalR
const connected = ref(false)

const _token = ref("");
const game = ref({});
const connection = new signalR.HubConnectionBuilder()
  .withUrl(process.env.VUE_APP_SERVER_GEKS ,{
    accessTokenFactory: () => _token.value
  })
  .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => timeoutReconnect })
  .build()

connection.onreconnected(() => connected.value = true)
connection.onreconnecting(() => connected.value = false)
connection.onclose(() => connected.value = false)

async function startConnection(token) {
  _token.value = token
  if (connection.state !== signalR.HubConnectionState.Disconnected) return
  try {
    await connection.start()
    connected.value = true
  } catch (err) {
    console.error(err)
    setTimeout(() => startConnection(token), timeoutReconnect)
  }
}


// client side
connection.on('Status', (gameStatus) => {
  console.log('Server Status:', gameStatus)
})

connection.on('ConfirmGame', (id, players) => {
   new Audio('/sounds/GameReady.mp3').play()
   status.value = EStatus.Approve
   game.value = { id, players }
})

connection.on('StartGame', (gameRecived) => {
    if(!game.value?.id) return
    game.value = gameRecived
    status.value = EStatus.InProgress
   
})

// game variables
const status = ref(EStatus.Undefined)

// composables/geks.js
const board = ref(null)  // board.value[row][col] = null | 'red' | 'blue'

// Ініціалізація порожньої дошки
function initBoard(size) {
    board.value = Array.from({ length: size }, () => Array(size).fill(null))
}

//connection.on("GameStarted", ({ boardSize, ...rest }) => {
//    initBoard(boardSize)
    // ...
//})

connection.on("MoveMade", ({ row, col, color }) => {
    if (board.value) board.value[row][col] = color
})

async function makeMove(row, col) {
    await connection.invoke("MakeMove", game.value.id, row, col)
}

export function geks() {
  return { connection, connected, startConnection, status, EStatus, game , board, makeMove}
}